import { render, staticRenderFns } from "./ChatSessionSummary.vue?vue&type=template&id=517b226e&scoped=true&"
import script from "./ChatSessionSummary.vue?vue&type=script&lang=js&"
export * from "./ChatSessionSummary.vue?vue&type=script&lang=js&"
import style0 from "./ChatSessionSummary.vue?vue&type=style&index=0&id=517b226e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517b226e",
  null
  
)

export default component.exports